import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    visRendered: false,
    introVisible: true,
    sidebarVisible: 'left',
    storyActive: 0,
    storyCount: null,
    snippetCurrent: 0,
    clustering: 'component',
    snippetCount: null,
    timeout: null,
    paragraphActive: 0,
    popupActive: false,
    popupPos: null,
    datasetCurrent: null,
    nodesAvailable: false,
    dataFetched: false,
    svgHeight: null,
    data: null,
    yearsExtend: null,
    sidebarToggled: null,
    scrolling: null,
    legendToggled: false,
    sidebarActive: true
  },
  mutations: {
    TOGGLE_LEGEND: (state, payload) => {
      state.legendToggled = payload;
    },
    SET_SCROLLING: (state, payload) => {
      state.scrolling = payload;
    },
    SET_INTRO_VISIBLE: (state, payload) => {
      state.introVisible = payload;
    },
    SET_SIDEBAR_VISIBLE: (state, payload) => {
      state.sidebarVisible = payload;      
    },
    SET_SIDEBAR_ACTIVE: (state, payload) => {
      state.sidebarActive = payload;      
    },
    SET_CURRENT_STORY: (state, payload) => {
      state.storyActive = payload;      
    },
    SET_STORIES_COUNT: (state, payload) => {
      state.storyCount = payload;      
    },
    SET_SNIPPET_CURRENT: (state, payload) => {
      state.snippetCurrent = payload;      
    },
    SET_SNIPPET_COUNT: (state, payload) => {
      state.snippetCount = payload;      
    },
    SET_VIS_RENDERED: (state, payload) => {
      state.visRendered = payload;      
    },
    SET_PARAGRAPH_ACTIVE: (state, payload) => {
      state.paragraphActive = payload;      
    },
    SET_POPUP_ACTIVE: (state, payload) => {
      state.popupActive = payload;      
    },
    SET_DATASET_CURRENT: (state, payload) => {
      state.datasetCurrent = payload;      
    },
    SET_NODES_AVAILABLE: (state, payload) => {
      state.nodesAvailable = payload;      
    },
    SET_DATA_FETCHED: (state, payload) => {
      state.dataFetched = payload;      
    },
    SET_SVG_HEIGHT: (state, payload) => {
      state.svgHeight = payload;      
    },
    SET_POPUP_POS: (state, payload) => {
      state.popupPos = payload;      
    },
    SET_TIMEOUT: (state, payload) => {
      state.timeout = payload;      
    },
    SET_DATA: (state, payload) => {
      state.data = payload;      
    },
    SET_CLUSTERING: (state, payload) => {
      state.clustering = payload;      
    },
    SET_YEARS_EXTEND: (state, payload) => {
      state.yearsExtend = payload;      
    },
    SET_SIDEBAR_TOGGLED: (state, payload) => {
      state.sidebarToggled = payload;      
    },
  },
  actions: {
    SET_INTRO_VISIBLE: (context, payload) => {
      context.commit('SET_INTRO_VISIBLE', payload);
    },
    SET_SCROLLING: (context, payload) => {
      context.commit('SET_SCROLLING', payload);
    },
    SET_CURRENT_STORY: (context, payload) => {
      context.commit('SET_CURRENT_STORY', payload);
    },
    SET_SIDEBAR_VISIBLE: (context,payload) => {
      context.commit('SET_SIDEBAR_VISIBLE', payload);
    },
    SET_SIDEBAR_ACTIVE: (context,payload) => {
      context.commit('SET_SIDEBAR_ACTIVE', payload);
    },
    SET_STORIES_COUNT: (context,payload) => {
      context.commit('SET_STORIES_COUNT', payload);
    },
    SET_SNIPPET_CURRENT: (context,payload) => {
      context.commit('SET_SNIPPET_CURRENT', payload);
    },
    SET_SNIPPET_COUNT: (context,payload) => {
      context.commit('SET_SNIPPET_COUNT', payload);
    },
    SET_VIS_RENDERED: (context,payload) => {
      context.commit('SET_VIS_RENDERED', payload);
    },
    SET_PARAGRAPH_ACTIVE: (context,payload) => {
      context.commit('SET_PARAGRAPH_ACTIVE', payload);
    },
    SET_POPUP_ACTIVE: (context,payload) => {
      context.commit('SET_POPUP_ACTIVE', payload);
    },
    SET_DATASET_CURRENT: (context, payload) => {
      context.commit('SET_DATASET_CURRENT', payload);
    },
    SET_NODES_AVAILABLE: (context, payload) => {
      context.commit('SET_NODES_AVAILABLE', payload);
    },
    SET_DATA_FETCHED: (context, payload) => {
      context.commit('SET_DATA_FETCHED', payload);
    },
    SET_SVG_HEIGHT: (context, payload) => {
      context.commit('SET_SVG_HEIGHT', payload);
    },
    SET_POPUP_POS: (context, payload) => {
      context.commit('SET_POPUP_POS', payload);
    },
    SET_TIMEOUT: (context, payload) => {
      context.commit('SET_TIMEOUT', payload);
    },
    SET_DATA: (context, payload) => {
      context.commit('SET_DATA', payload);
    },
    SET_CLUSTERING: (context, payload) => {
      context.commit('SET_CLUSTERING', payload);
    },
    SET_YEARS_EXTEND: (context, payload) => {
      context.commit('SET_YEARS_EXTEND', payload);
    },
    SET_SIDEBAR_TOGGLED: (context, payload) => {
      context.commit('SET_SIDEBAR_TOGGLED', payload);
    },
    TOGGLE_LEGEND: (context, payload) => {
      context.commit('TOGGLE_LEGEND', payload);
    },
  }
})
